import React from 'react';
import { useGetId } from 'utils/hooks';
import Swal from 'sweetalert2';

import Form from 'Forms/Origin';
import Layout from 'layouts/MainForm';

export default function Save() {
  const save = useGetId();

  return (
    <Layout
      component={Form}
      options={save}
      onCreate={() => {
        Swal.fire({
          icon: 'success',
          title: 'Creado',
          text: 'Nueva procedencia creada.',
        });
      }}
      onUpdate={() => {
        Swal.fire({
          icon: 'success',
          title: 'Guardado',
          text: 'Procedencia guardada.',
        });
      }}
    />
  );
}
